module.exports = __webpack_public_path__ + "static/media/term1.3bf37ea0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/terminology/assets/term1.svg
// module id = 126
// module chunks = 0